import { AxiosHeaders, AxiosRequestConfig } from 'axios';

import { getWebStoreApiClient } from '@gn-audio/core';

import { getAuthBearerValue } from '../../auth/web-store-api/utilities';
import { HttpHeader } from '../../common';

export const getPricingHeaders = async (shopApiClientId?: string): Promise<AxiosRequestConfig> => {
  const requestHeaders = new AxiosHeaders();

  if (shopApiClientId) {
    requestHeaders.set(HttpHeader.ClientId, shopApiClientId);
  } else {
    console.warn('SFCC Client ID is not set');
  }
  const token = await getWebStoreApiClient().onTokenAcquired;

  requestHeaders.set('Authorization', getAuthBearerValue(token));

  return { headers: requestHeaders, withCredentials: true };
};

export const isAuthorized = (): boolean => {
  return !!getWebStoreApiClient().account;
};
